var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext, useEffect } from 'react';
var AppContext = createContext(undefined);
export var useAppContext = function () {
    var context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within a AppProvider');
    }
    return context;
};
export var AppProvider = function (_a) {
    var children = _a.children, appConfig = _a.appConfig;
    var _b = useState(''), stepHistory = _b[0], setStepHistory = _b[1];
    var _c = useState({
        email: '',
        phone: '',
        zip: '',
        message: '',
    }), formData = _c[0], setFormData = _c[1];
    var _d = useState('navigation'), activeStep = _d[0], setActiveStep = _d[1];
    var _e = useState(''), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = useState(''), successMessage = _f[0], setSuccessMessage = _f[1];
    var _g = useState(false), menuOpen = _g[0], setMenuOpen = _g[1];
    var handleActiveStep = function (step) {
        setActiveStep(step);
        if (step === 'submitted') {
            localStorage.setItem('activeStep', 'navigation');
        }
        else {
            localStorage.setItem('activeStep', step);
        }
    };
    useEffect(function () {
        if (activeStep && activeStep !== 'navigation') {
            var stepTitle_1 = activeStep === 'submitted' ?
                appConfig.translations.submitted : appConfig.forms[activeStep].buttonText;
            setStepHistory(function (prevStepHistory) {
                return prevStepHistory ? prevStepHistory + '->' + stepTitle_1 : stepTitle_1;
            });
        }
    }, [activeStep]);
    return (_jsx(AppContext.Provider, __assign({ value: {
            handleActiveStep: handleActiveStep,
            menuOpen: menuOpen,
            setMenuOpen: setMenuOpen,
            formData: formData,
            setFormData: setFormData,
            appConfig: appConfig,
            activeStep: activeStep,
            stepHistory: stepHistory,
            errorMessage: errorMessage,
            setErrorMessage: setErrorMessage,
            successMessage: successMessage,
            setSuccessMessage: setSuccessMessage,
        } }, { children: children })));
};
